import { LineOfBusiness } from "../../app/types";

export const MEDICAL_PANEL_DOCUMENT_TYPE = "MEDICAL_PANEL";
export const STATE_FORM_DOCUMENT_TYPE = "STATE_FORM";
export const AUTHORIZATION_FORM_DOCUMENT_TYPE = "AUTHORIZATION_FORM";
export const WC_CLAIM_ATTACHMENT = "WC_CLAIM_ATTACHMENT";
export const CARGO_CLAIM_ATTACHMENT = "CARGO_CLAIM_ATTACHMENT";
export const INTERNATIONAL_PRODUCT_LIABILITY_CLAIM_ATTACHMENT =
  "INTERNATIONAL_PRODUCT_LIABILITY_CLAIM_ATTACHMENT";
export const MULTIPLE_ITEM_CLAIM_ATTACHMENT_TEMPLATE = "MULTIPLE_ITEM_CLAIM_ATTACHMENT_TEMPLATE";
export const WC_CANADA_PROVINCE_FORM_DOCUMENT_TYPE = "WC_CANADA_PROVINCE_FORM";

export const DOCUMENT_TYPE_LABELS: { [key: string]: string } = {
  [MEDICAL_PANEL_DOCUMENT_TYPE]: "Preferred Provider Panels",
  [STATE_FORM_DOCUMENT_TYPE]: "State Forms",
  [AUTHORIZATION_FORM_DOCUMENT_TYPE]: "Authorization Forms",
  [WC_CANADA_PROVINCE_FORM_DOCUMENT_TYPE]: "Province Forms",
};

export const UPLOAD_BUCKET = {
  [LineOfBusiness.WORKERS_COMPENSATION]: WC_CLAIM_ATTACHMENT,
  [LineOfBusiness.CARGO]: CARGO_CLAIM_ATTACHMENT,
  [LineOfBusiness.IPL]: INTERNATIONAL_PRODUCT_LIABILITY_CLAIM_ATTACHMENT,
  [LineOfBusiness.ATOZ]: INTERNATIONAL_PRODUCT_LIABILITY_CLAIM_ATTACHMENT,
};
